import { axiosInstance } from '@/utils/api'
import { IIpRange } from '@/utils/types'

export async function setOrganizationWhiteList(data: { whiteListIp: IIpRange[] }) {
  return (await axiosInstance.post('/organization/ipWhitelist', data))?.data
}
